import { updates, contactInfo } from '@/mocks/home';

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">最新快讯</h2>
          <p className="text-foreground-600 max-w-[600px] mx-auto">各频道每日动态一览，不错过任何影视热点</p>
        </div>
        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-300">
            {updates.map((item, i) => (
              <div key={i} className={`relative pb-10 ${i === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute -left-[41px] md:-left-[45px] top-0 w-4 h-4 rounded-full bg-primary-500 border-4 border-background-100"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">{item.date}</span>
                  <span className="hidden sm:inline text-foreground-400">·</span>
                  <span className="inline-flex bg-accent-100 text-accent-700 text-xs px-2.5 py-0.5 rounded-full font-medium whitespace-nowrap w-fit">{item.tag}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-100 rounded-3xl p-8 md:p-12 lg:p-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">移动观影，随时随地</h2>
            <p className="text-foreground-600 leading-relaxed mb-6">
              麻花影视完美适配手机浏览器，无需下载 App 即可享受流畅的高清观影体验。在地铁上、午休时、旅行中，打开手机就能继续追你喜欢的剧集。智能流量优化技术，用最少的数据看最清晰的画面。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 bg-background-50 px-4 py-2.5 rounded-full">
                <i className="ri-smartphone-line text-primary-500 text-lg"></i>
                <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">手机浏览器直接访问</span>
              </div>
              <div className="flex items-center gap-2 bg-background-50 px-4 py-2.5 rounded-full">
                <i className="ri-4k-line text-primary-500 text-lg"></i>
                <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">1080P 高清画质</span>
              </div>
              <div className="flex items-center gap-2 bg-background-50 px-4 py-2.5 rounded-full">
                <i className="ri-wifi-line text-primary-500 text-lg"></i>
                <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">智能省流量</span>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-[240px] h-[480px] rounded-[2.5rem] border-[6px] border-foreground-800 overflow-hidden bg-background-200">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80px] h-[24px] bg-foreground-800 rounded-b-2xl z-10"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20showing%20a%20movie%20streaming%20app%20interface%20in%20Chinese%2C%20with%20movie%20poster%20thumbnails%20grid%20layout%2C%20warm%20dark%20theme%2C%20modern%20UI%20design%2C%20clean%20and%20polished%20mobile%20app%20aesthetic&width=480&height=960&seq=mahua-app-mockup&orientation=portrait"
                alt="麻花影视移动端观影界面"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[640px] mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">{contactInfo.title}</h2>
          <p className="text-foreground-600 leading-relaxed mb-8">{contactInfo.description}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-3 bg-background-50 rounded-xl px-6 py-4 flex-1 w-full sm:w-auto justify-center">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">投稿与合作</div>
                <div className="text-sm font-semibold text-foreground-800">contact@mahua.tv</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-background-50 rounded-xl px-6 py-4 flex-1 w-full sm:w-auto justify-center">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                <i className="ri-chat-smile-2-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">内容反馈</div>
                <div className="text-sm font-semibold text-foreground-800">feedback@mahua.tv</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}